// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2_AvN","title":"Info_title__3WVLE","links":"Info_links__1mVnK","link":"Info_link__3Q0PT","logo":"Info_logo__2Uvt0"};